module.exports = __webpack_public_path__ + "static/boost-30f2c7d42b6bba195ae97f6af214d37e.svg";